<template>
  <div>
      <v-card 
        v-for="order in orders" 
        :key="order.sale.ID" 
        :color="getStatusColor(order)"
        class="mb-4"
      >
        <v-card-item>
          <template v-slot:prepend>
            <v-icon
              :icon="order.success ? 'mdi-check-circle' : 'mdi-alert'"
              :color="order.success ? 'success' : 'error'"
              size="large"
            ></v-icon>
          </template>
          
          <v-card-title>
            Order {{ order.sale.ID }} - {{ order.sale.PONumber }}
          </v-card-title>

          <template v-if="!order.success">
            <v-card-subtitle class="text-error">
              {{ order.error }}
            </v-card-subtitle>
          </template>
        </v-card-item>

        <v-divider v-if="order.success"></v-divider>

        <v-card-text v-if="order.success">
          <order-item
            :key="order.sale.ID"
            :order="order.sale"
            :selected="isSelected(order.sale)"
            @selection-changed="$emit('selection-changed', $event)"
          />
        </v-card-text>
        <v-card-text v-if="order.servicelevel">
          {{ order.servicelevel }}
        </v-card-text>
        <v-card-text v-if="order.notes">
          {{ order.notes }}
        </v-card-text>
      </v-card>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import OrderItem from './OrderItem.vue'

const props = defineProps({
  orders: {
    type: Array,
    required: true
  },
  selectedOrders: {
    type: Array,
    required: true
  }
})

defineEmits(['selection-changed'])

const isSelected = (sale) => {
  return props.selectedOrders.some(o => o.sale.ID === sale.ID)
}

const getStatusColor = (order) => {
  if (!order.success) return 'error-lighten-4'
  if (order.original_cost !== order.verified_cost) return 'warning-lighten-4'
  return undefined
}

</script> 